export const toNumber = (value) => {
  if (value === '' || value === null || value === undefined) return 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const money = (value) => toNumber(value).toFixed(2);

export const dateInput = (value) => {
  if (!value) return '';
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
    const [m, d, y] = raw.split('/');
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  }
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export const displayDate = (value) => {
  const normalized = dateInput(value);
  if (!normalized) return '';
  const [y, m, d] = normalized.split('-');
  return `${m}/${d}/${y}`;
};

export const periodFromDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
};

export const formatPeriodLabel = (period) => {
  if (!period) return '-';
  const [yearValue, monthValue] = period.split('-').map((part) => parseInt(part, 10));
  if (!yearValue || !monthValue) return period;
  return new Date(yearValue, monthValue - 1, 1).toLocaleString('en-US', { month: 'long', year: 'numeric' });
};

export const daysInPeriod = (period) => {
  if (!period) return 0;
  const [yearValue, monthValue] = period.split('-').map((part) => parseInt(part, 10));
  if (!yearValue || !monthValue) return 0;
  return new Date(yearValue, monthValue, 0).getDate();
};

export const makeRowId = () => `row-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const makeBlankRow = (period, invoiceDate) => ({
  id: makeRowId(),
  plate_no: '',
  allocation_date: invoiceDate || (period ? `${period}-01` : ''),
  base_amount: '',
  gross_amount: '',
  discount_amount: '',
  prorated_amount: '0.00',
  days_counted: '',
  note: '',
  invoice_period: period || '',
  include: true
});

export const makeRowFromCar = (car, period, invoiceDate, defaultAmount = 0) => {
  const grossAmount = money(defaultAmount);
  const discount = money(car?.discount_amount ?? 0);
  const gross = toNumber(grossAmount);
  const discountValue = Math.max(0, Math.min(toNumber(discount), gross));
  const net = Math.max(0, gross - discountValue);

  return {
    id: `${String(car?.plate_no || 'line').toUpperCase()}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    plate_no: String(car?.plate_no || ''),
    allocation_date: dateInput(car?.allocation_date) || invoiceDate || (period ? `${period}-01` : ''),
    base_amount: grossAmount,
    gross_amount: grossAmount,
    discount_amount: money(discountValue),
    prorated_amount: money(net),
    days_counted: period ? String(daysInPeriod(period)) : '',
    note: '',
    invoice_period: period || '',
    include: true
  };
};

export const normalizeRow = (row, period, invoiceDate, index) => {
  const gross = toNumber(row?.gross_amount ?? row?.base_amount ?? 0);
  const discount = Math.max(0, Math.min(toNumber(row?.discount_amount ?? 0), gross));
  const net = Math.max(0, gross - discount);

  return {
    id: `${String(row?.plate_no || 'line').toUpperCase()}-${index}-${Date.now()}`,
    plate_no: String(row?.plate_no || ''),
    allocation_date: dateInput(row?.allocation_date) || invoiceDate || (period ? `${period}-01` : ''),
    base_amount: money(row?.base_amount ?? row?.gross_amount ?? 0),
    gross_amount: money(gross),
    discount_amount: money(discount),
    prorated_amount: money(row?.prorated_amount ?? net),
    days_counted: String(row?.days_counted ?? ''),
    note: String(row?.note || row?.notes || ''),
    invoice_period: row?.invoice_period || period || '',
    include: row?.include !== false
  };
};
